module.exports = __webpack_public_path__ + "img/install_theme_icon_3.b8ff6250.png";